import type { FC, PropsWithChildren } from 'react';

type TableProps = PropsWithChildren<{}>;

const Table: FC<TableProps> = props => {
  return <tbody>{props.children}</tbody>;
};

export default Table;
